import React, { useState } from 'react'
import { Box } from '@chakra-ui/react'
import { FaPaw } from 'react-icons/fa6'

import ChatInfoAccordionItem from '../info-accordion-item'
import InfoEmptyPlaceholder from '../info-empty-placeholder'
import InfoLoadingPlaceholder from '../info-loading-placeholder'
import { eqBoolFilter, eqStringFilter } from '~utils/query-helpers'
import AsyncWrapper from '~components/shared/wrappers/async-wrapper'
import {
    ChatFieldsFragment,
    useQueryPatientsQuery,
} from '~graphql/generated/graphql'
import ChatClientDetailsPatientItem from './patient-item'

interface Props {
    chat: ChatFieldsFragment
}

export default function ChatClientDetailsPatients({ chat }: Props) {
    const { client } = chat

    const [isOpen, setIsOpen] = useState(false)

    const { data, loading } = useQueryPatientsQuery({
        variables: {
            where: [
                eqStringFilter('owner', client?.id),
                eqBoolFilter('is_active', true),
                eqBoolFilter('is_deceased', false),
            ],
            page: 0,
            pageSize: 5,
            orderBy: {
                column: 'name',
                isAscending: true,
            },
        },
        skip: !client || !isOpen,
    })

    const patients = data?.queryPatients || []

    return (
        <ChatInfoAccordionItem
            icon={FaPaw}
            title="Patients"
            isOpenState={isOpen}
            setIsOpenState={setIsOpen}
        >
            <Box px={4} pt={2} pb={3}>
                <AsyncWrapper
                    loading={loading}
                    loadingComponent={<InfoLoadingPlaceholder />}
                    empty={patients.length === 0}
                    emptyComponent={<InfoEmptyPlaceholder item="patients" />}
                >
                    {patients.map(patient => (
                        <ChatClientDetailsPatientItem
                            key={patient.id}
                            chat={chat}
                            patient={patient}
                        />
                    ))}
                </AsyncWrapper>
            </Box>
        </ChatInfoAccordionItem>
    )
}
